export const APP_CONTEXT = Symbol('APP_CONTEXT_INJECTION_TOKEN');
